import { Order } from '@/shared/interfaces/order';
import { UserProfile } from '@/shared/interfaces/user';
import { Wallet } from './balance';

export class RfidTag {
	user: UserProfile;
	wallets: Wallet[];
	refund_requests: any[];
	pending_refund_requests: any[];
	approved_refund_requests: any[];

	constructor(
		public id: number | string | null = null,
		public uuid: string = 'UUID',
		public latest_product_order: Order,
		public is_refundable: boolean | null,
	) {
		this.is_refundable = is_refundable;
		this.user = new UserProfile();
		this.wallets = [];
		this.refund_requests = [];
		this.pending_refund_requests = [];
		this.approved_refund_requests = [];
	}
}
